export class RestoreJobTypeFilters {
    '_in';
    'notIn';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<RestoreJobType>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<RestoreJobType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreJobTypeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
